import { X, CalendarDays, Clock, MapPin, Users, Pencil, Trash2, Mail } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { calendarOf, formatTime, formatDayLong, tzLabel, sameDay } from '../../lib/calendar';
import { getInitials, getAvatarColor } from '../../lib/avatar';

// Sağdaki etkinlik detay paneli
export const EventPanel = ({ event, onClose, onEdit, onDelete, onEmailAttendees }) => {
  const calendar = calendarOf(event.color);
  const lastDay = event.all_day ? new Date(event.end.getTime() - 1) : event.end;
  const multiDay = !sameDay(event.start, lastDay);

  return (
    <aside className="w-full md:w-[320px] shrink-0 border-l border-border bg-background overflow-y-auto" data-testid="event-panel">
      <div className="flex items-start justify-between gap-2 p-5 pb-3">
        <h2 className="text-lg font-semibold flex items-start gap-2 min-w-0">
          <span className={`mt-1.5 h-3 w-3 shrink-0 rounded-full ${calendar.dot}`} />
          <span className="break-words">{event.title}</span>
        </h2>
        <Button variant="ghost" size="icon" onClick={onClose} aria-label="Paneli kapat" className="shrink-0" data-testid="event-panel-close"><X className="h-4 w-4" /></Button>
      </div>

      <div className="px-5 pb-5 space-y-4 text-sm">
        <div className="flex items-start gap-3">
          <CalendarDays className="h-4 w-4 mt-0.5 text-muted-foreground shrink-0" />
          <div>
            <p>{formatDayLong(event.start)}</p>
            {multiDay && <p className="text-muted-foreground">– {formatDayLong(lastDay)}</p>}
          </div>
        </div>
        <div className="flex items-start gap-3">
          <Clock className="h-4 w-4 mt-0.5 text-muted-foreground shrink-0" />
          <div>
            <p>{event.all_day ? 'Tüm gün' : `${formatTime(event.start)} – ${formatTime(event.end)}`}</p>
            {!event.all_day && <p className="text-muted-foreground">{tzLabel()}</p>}
          </div>
        </div>
        {event.location && (
          <div className="flex items-start gap-3"><MapPin className="h-4 w-4 mt-0.5 text-muted-foreground shrink-0" /><p className="break-words">{event.location}</p></div>
        )}
        <div className="flex items-center gap-3">
          <span className="w-4 flex justify-center shrink-0"><span className={`h-2.5 w-2.5 rounded-full ${calendar.dot}`} /></span>
          <p>{calendar.name}</p>
        </div>

        {event.attendees?.length > 0 && (
          <div>
            <p className="flex items-center gap-2 font-medium mb-2"><Users className="h-4 w-4 text-muted-foreground" /> Katılımcılar</p>
            <ul className="space-y-2">
              {event.attendees.map((email) => (
                <li key={email} className="flex items-center gap-3">
                  <span className={`h-8 w-8 shrink-0 rounded-full text-xs font-semibold flex items-center justify-center ${getAvatarColor(email)}`}>{getInitials('', email)}</span>
                  <span className="truncate">{email}</span>
                </li>
              ))}
            </ul>
          </div>
        )}

        {event.description && (
          <div>
            <p className="font-medium mb-1">Açıklama</p>
            <p className="text-muted-foreground whitespace-pre-line break-words">{event.description}</p>
          </div>
        )}

        <div className="flex flex-wrap gap-2 pt-2">
          <Button variant="outline" onClick={() => onEdit(event)} data-testid="event-edit"><Pencil className="h-4 w-4 mr-2" /> Düzenle</Button>
          <Button variant="outline" className="text-destructive" onClick={() => onDelete(event)} data-testid="event-delete"><Trash2 className="h-4 w-4 mr-2" /> Sil</Button>
        </div>
        {event.attendees?.length > 0 && (
          <Button variant="ghost" className="text-primary px-0 hover:bg-transparent hover:underline" onClick={() => onEmailAttendees(event)} data-testid="event-email-attendees">
            <Mail className="h-4 w-4 mr-2" /> Katılımcılara e-posta gönder
          </Button>
        )}
      </div>
    </aside>
  );
};

export default EventPanel;
